import { ColorTypes } from '@genial/design-tokens';
import {
  ResponsesEquityPositionByAccountResponse,
  ResponsesEquityResponse,
} from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { EquityOfferEntityNormalized } from '../types';

const normalizePriceChangeTaxColor = (priceChangeTax: number): ColorTypes.Option => {
  return priceChangeTax >= 0 ? 'feedback.success.default' : 'feedback.error.default';
};

interface EquityOffersResponseData extends Partial<ResponsesEquityPositionByAccountResponse> {
  equity: ResponsesEquityResponse['equity'];
}

export const normalizeEquityOffers = (
  data?: EquityOffersResponseData[] | null
): EquityOfferEntityNormalized[] => {
  if (!data) {
    return [];
  }

  return data.map(({ equity, availableAmount }) => {
    return {
      ...equity,
      productIdNormalized: equity.quote.productId || '',
      productNameNormalized: equity.quote.productName || '',
      symbolNormalized: equity.quote.symbol || '',
      imageNormalized: equity?.quote?.icons?.light || '',
      lastPriceNormalized: Utils.Mask.Money(equity.quote.lastPrice),
      priceChangeTaxNormalized: Utils.Mask.Percentage(equity.quote.priceChangeTax),
      tradeDateNormalized: `Atualizado às ${Utils.Mask.DateFormat(
        equity.quote.tradeDate,
        'HH:mm'
      )}`,
      askPriceNormalized: Utils.Mask.Money(equity.quote.askPrice),
      closePriceNormalized: Utils.Mask.Money(equity.quote.closePrice),
      bidPriceNormalized: Utils.Mask.Money(equity.quote.bidPrice),
      priceNormalized: equity.quote.lastPrice,
      priceNormalizedFormatted: Utils.Mask.Money(equity.quote.lastPrice),
      priceChangeTaxValueNormalized: equity.quote.priceChangeTax,
      priceChangeTaxColorNormalized: normalizePriceChangeTaxColor(equity.quote.priceChangeTax),
      saleAvailableAmount: availableAmount,
    };
  });
};
